import * as Yup from "yup";

export const ResetPasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required(),
  newPassword: Yup.string().required(),
  confirmPassword: Yup.string().oneOf([Yup.ref('newPassword'), null])
})
